import React from 'react';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { SCREENS } from '~constants';
import AppScreens from './AppScreens/AppScreens';
import PaymentSuccess from '~containers/Event/PaymentSuccess/PaymentSuccess';
import SubscriptionDetailsScreen from '~containers/Subscriptions/SubscriptionDetailsScreen';
import RateEvent from '~containers/Event/RateEvent/RateEvent';

const Stack = createNativeStackNavigator();

const AppRoot = () => {
  return (
    <Stack.Navigator
      screenOptions={{
        headerShown: false,
        gestureEnabled: false,
        animation: 'default',
      }}
    >
      {/* Main tab navigator */}
      <Stack.Screen name={SCREENS.BOTTOM_BAR} component={AppScreens} />
      
      {/* Independent screens without tab bar */}
      <Stack.Screen 
        name={SCREENS.PAYMENT_SUCCESS} 
        component={PaymentSuccess}
        options={{
          headerShown: false,
          presentation: 'card',
        }}
      />

      <Stack.Screen 
        name={SCREENS.RATE_EVENT} 
        component={RateEvent}
        options={{
          headerShown: false,
          presentation: 'card',
        }}
      />
      {/* Subscriptions screen - accessible from any stack */}
      <Stack.Screen
        name={SCREENS.SUBSCRIPTIONS}
        component={SubscriptionDetailsScreen}
        options={{
          headerShown: false,
          presentation: 'card',
        }}
      />
    </Stack.Navigator>
  );
};

export default AppRoot;